import { dataDelete, dataOn, dataOnce, dataPush, dataRef } from "../data/data";
import { getPageId } from "../state/pageId";
import { refresh } from "./refresh";
export function refreshListener() {
    const pagesRef = dataRef("refresh/pages");
    const pageId = getPageId();
    dataOn("refresh/init", (init) => {
        if (init === pageId || init === true) {
            dataOnce(pagesRef).then(() => {
                // TODO: Test this out again and make sure it's adding value
                dataPush(pagesRef, pageId);
            });
            dataDelete(`active/${pageId}`);
            refresh();
        }
    });
}
